import { render, staticRenderFns } from "./CreateGuardia.vue?vue&type=template&id=6cafc692&"
import script from "./CreateGuardia.vue?vue&type=script&lang=js&"
export * from "./CreateGuardia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports